export default "__VITE_ASSET__1db85e84__"